import type { SiteSettings } from '@lambda/shared/types';
import {
  ADMIN_MAINTENANCE_BANNER_MESSAGE,
  ENROLLMENT_SUSPENDED_DURING_MAINTENANCE_MESSAGE,
  PARENT_LOGIN_BLOCKED_DURING_MAINTENANCE_MESSAGE,
} from '@lambda/shared/siteMaintenanceModeMessages';

export {
  ADMIN_MAINTENANCE_BANNER_MESSAGE,
  ENROLLMENT_SUSPENDED_DURING_MAINTENANCE_MESSAGE,
  PARENT_LOGIN_BLOCKED_DURING_MAINTENANCE_MESSAGE,
};

export function isSiteMaintenanceModeOn(settings: SiteSettings | null | undefined): boolean {
  return settings?.siteMaintenanceMode === true;
}

export function isEnrollmentSuspendedDuringMaintenance(
  settings: SiteSettings | null | undefined
): boolean {
  return isSiteMaintenanceModeOn(settings);
}

/** Routes that stay reachable during maintenance (login, legal, invited-user onboarding). */
export const PATHS_AVAILABLE_DURING_MAINTENANCE = new Set([
  '/login',
  '/terms',
  '/privacy',
  '/complete-invitation',
  '/verify-email',
  '/verify-phone',
  '/setup-2fa',
  '/onboarding-complete',
  '/forgot-password',
  '/reset-password',
  '/confirm-email-change',
]);

export function isPathAvailableDuringMaintenance(pathname: string): boolean {
  if (PATHS_AVAILABLE_DURING_MAINTENANCE.has(pathname)) return true;
  return pathname.startsWith('/login/');
}
